import request from '../../../../util/APIUtils';
import { PORTAL_API_BASE_URL } from '../../../../constants';

/**
 * Fetches a single case plan with sections and widgets for the admin detail view.
 * @param {string} casePlanId - UUID of the case plan
 * @returns {Promise<{ plan: object, sections: object[] }>}
 */
export const fetchCasePlanDetail = (casePlanId, signal) =>
  request({
    url: `${PORTAL_API_BASE_URL}/api/admin/case-plan/${casePlanId}`,
    method: 'GET',
    signal,
  });

/**
 * Queues a case plan export for the selected sections.
 * @param {string} casePlanId - UUID of the case plan
 * @param {{ emails: string[], password: string, sectionIds: string[] }} payload
 */
export const exportCasePlan = (casePlanId, { emails, password, sectionIds }) =>
  request({
    url: `${PORTAL_API_BASE_URL}/api/admin/case-plan/${casePlanId}/export`,
    method: 'POST',
    body: JSON.stringify({
      emails,
      password,
      sectionIds,
    }),
  });
